/**
 * Tab-scoped session JWT for Authorization: Bearer.
 * Complements the httpOnly cookie. sessionStorage (not localStorage) keeps the
 * token for this tab only so cross-site cookie gaps cannot flash-logout admins.
 */
export const SESSION_TOKEN_STORAGE_KEY = "taistu_session_jwt";

let memoryToken = null;

function readStored() {
  try {
    if (typeof sessionStorage === "undefined") return null;
    const v = sessionStorage.getItem(SESSION_TOKEN_STORAGE_KEY);
    return v && v.trim() ? v.trim() : null;
  } catch {
    return null;
  }
}

function writeStored(token) {
  try {
    if (typeof sessionStorage === "undefined") return;
    if (token) sessionStorage.setItem(SESSION_TOKEN_STORAGE_KEY, token);
    else sessionStorage.removeItem(SESSION_TOKEN_STORAGE_KEY);
  } catch {
    // ignore quota / private mode
  }
}

/** Copy the current tab JWT into another same-origin window (new library tab). */
export function seedSessionTokenIntoWindow(win) {
  const token = getSessionToken();
  if (!token || !win) return false;
  try {
    win.sessionStorage.setItem(SESSION_TOKEN_STORAGE_KEY, token);
    return true;
  } catch {
    return false;
  }
}

export function getSessionToken() {
  if (memoryToken) return memoryToken;
  const stored = readStored();
  if (stored) memoryToken = stored;
  return memoryToken;
}

export function setSessionToken(token) {
  const t = typeof token === "string" ? token.trim() : "";
  memoryToken = t || null;
  writeStored(memoryToken);
}

export function clearSessionToken() {
  memoryToken = null;
  writeStored(null);
}
